/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getAcademicTranscriptPreviewDataApi,
    generateAcademicTranscriptApi,
    getLatestAcademicTranscriptApi,
    downloadAcademicTranscriptApi,
} from "@/api/reportingApi";
import { AcademicTranscriptPreviewInterface } from "@/ts/interfaces/Reporting/AcademicTranscriptPreviewInterface";
import { mapAcademicTranscriptPreviewApiData } from "@/utils/reportingDataMapper";

// 1) Preview (maps raw -> typed preview)
export const fetchAcademicTranscriptPreviewThunk = createAsyncThunk<
    { data: AcademicTranscriptPreviewInterface },
    { student: number; productFamilyGradeId: number; term: number | string },
    { rejectValue: string }
>("reporting/academicTranscript/preview", async ({ student, productFamilyGradeId, term }, { rejectWithValue }) => {
    try {
        const { data: { data: raw } } = await getAcademicTranscriptPreviewDataApi(student, productFamilyGradeId, String(term));
        const data = mapAcademicTranscriptPreviewApiData(raw);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to fetch preview");
    }
});

// 2) Generate (return raw)
export const generateAcademicTranscriptThunk = createAsyncThunk<
    { data: any },
    { studentId: number; productFamilyGradeId: number; gradeCode: number; term: number, year: number },
    { rejectValue: string }
>("reporting/academicTranscript/generate", async ({ studentId, productFamilyGradeId, gradeCode, term, year }, { rejectWithValue }) => {
    try {
        const { data } = await generateAcademicTranscriptApi(studentId, productFamilyGradeId, gradeCode, term, year);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to generate academic transcript");
    }
});

// 3) Latest (return raw)
export const getLatestAcademicTranscriptThunk = createAsyncThunk<
    { data: any },
    { studentId: number; productFamilyGradeId: number; term: number },
    { rejectValue: string }
>("reporting/academicTranscript/latest", async ({ studentId, productFamilyGradeId, term }, { rejectWithValue }) => {
    try {
        const { data } = await getLatestAcademicTranscriptApi(studentId, productFamilyGradeId, term);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to fetch latest academic transcript");
    }
});

// 4) Download (return raw)
export const downloadAcademicTranscriptThunk = createAsyncThunk<
    { data: any },
    { asset: number },
    { rejectValue: string }
>("reporting/academicTranscript/download", async ({ asset }, { rejectWithValue }) => {
    try {
        const { data } = await downloadAcademicTranscriptApi(asset);
        return { data };
    } catch (e: any) {
        return rejectWithValue(e?.message ?? "Failed to download academic transcript");
    }
});
